import moment from 'moment';
import {DATETIME_FORMAT} from './date.model';

export class CssModel {
  asset: string;
  assetLabel: string;
  country: string;
  cssData: CssDataModel[];
}

export class CssDataModel {
  css: number;
  ts: string;

  constructor(objIn: any) {
    this.css = objIn.value || null;
    this.ts = objIn.timestamp
      ? moment.utc(objIn.timestamp).local().format(DATETIME_FORMAT)
      : '';
  }
}
